/**
 * ZEN ERP — Merkezi Ses Yardımcısı
 * İnce, rahatsız etmeyen bip sesleri + global toggle
 */

const PREF_KEY = "zen_sounds_enabled";

export function isSoundEnabled() {
  const v = localStorage.getItem(PREF_KEY);
  return v === null ? true : v === "true";   // varsayılan: açık
}

export function setSoundEnabled(val) {
  localStorage.setItem(PREF_KEY, val ? "true" : "false");
  window.dispatchEvent(new CustomEvent("zen-sound-pref-changed", { detail: { enabled: val } }));
}

/**
 * İnce bip sesi çalar.
 * @param {"notify" | "success" | "soft"} type
 *   notify  — hatırlatıcı alarmı   (tek bip, 600 Hz, 110ms)
 *   success — işlem tamamlandı     (kısa yükselen, 700→900 Hz, 90ms)
 *   soft    — bilgi / sessiz uyarı (çok hafif, 480 Hz, 80ms)
 */
export function playBeep(type = "notify") {
  if (!isSoundEnabled()) return;
  try {
    const ac = new (window.AudioContext || window.webkitAudioContext)();
    const o = ac.createOscillator();
    const g = ac.createGain();
    o.type = "sine";

    const now = ac.currentTime;
    if (type === "success") {
      o.frequency.setValueAtTime(700, now);
      o.frequency.linearRampToValueAtTime(900, now + 0.09);
      g.gain.setValueAtTime(0.07, now);
      g.gain.exponentialRampToValueAtTime(0.001, now + 0.12);
      o.connect(g); g.connect(ac.destination);
      o.start(now); o.stop(now + 0.13);
    } else if (type === "soft") {
      o.frequency.value = 480;
      g.gain.setValueAtTime(0.05, now);
      g.gain.exponentialRampToValueAtTime(0.001, now + 0.08);
      o.connect(g); g.connect(ac.destination);
      o.start(now); o.stop(now + 0.09);
    } else {
      // notify — hatırlatıcı için tek kısa bip
      o.frequency.value = 600;
      g.gain.setValueAtTime(0.08, now);
      g.gain.exponentialRampToValueAtTime(0.001, now + 0.11);
      o.connect(g); g.connect(ac.destination);
      o.start(now); o.stop(now + 0.12);
    }
  } catch { /* ses desteklenmiyorsa sessiz geç */ }
}
